import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SGKB991AService, Sgkb991aRequest, Sgkb991aResponse} from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb991aService {
  /** 部署情報検索結果のSubject */
  private _departmentInfoSearchResult$: Subject<Sgkb991aResponse> = new Subject<Sgkb991aResponse>();

  /**
   * 部署情報検索結果のobservable提供
   * @readonly
   * @memberof UsedSgkb991aService
   */
  get departmentInfoSearchChanges(): Observable<Sgkb991aResponse> {
    return this._departmentInfoSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKB991AService} SGKB991AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @memberof UsedSgkb991aService
   */
  constructor(
    private sGKB991AService: SGKB991AService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   *部署情報検索API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Sgkb991aResponse>}
   * @memberof UsedSgkb991aService
   */
  searchContractor(value: Sgkb991aRequest): Observable<Sgkb991aResponse> {
    // 年月日項目のフォーマット
    this.apiCommonService.convertElementInObject(value, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    // 検索条件を保存
    return this.sGKB991AService.SGKB991APost(<Sgkb991aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._departmentInfoSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SGKB991A);
          return throwError(err.message);
        })
      );
  }
}
